import { h } from 'preact';

import Card from '../../3-molecules/card/card';
import VideoCardInline from '../../3-molecules/video-card-inline/video-card-inline';
import VideoCardInlineSlim from '../../3-molecules/video-card-inline-slim/video-card-inline-slim';

import { C_CARD_CLASSNAME, C_VIDEO_CARD_INLINE_CLASSNAME, C_VIDEO_CARD_INLINE_SLIM_CLASSNAME } from './costants';

export const getCardRenderers = ({ cardsStyles, cardTag, deviceType, cardInstance, handleCardClick }) => ({
  [C_CARD_CLASSNAME]: (card, index) => (
    <Card
      key={index}
      modifiers={cardsStyles[deviceType] ? cardsStyles[deviceType].modifiers : []}
      newsData={{
        section: card.section,
        title: card.title,
        url: card.url,
        urlImage: card.urlImage[deviceType],
      }}
      intcmpCard={card.intcmp}
      target={card.target}
      time={card.time}
      rel={card.rel}
      imageAspectRatio={card.imageAspectRatio[deviceType]}
      labelModifiers={card.labelModifiers}
      ref={cardInstance}
    />
  ),
  [C_VIDEO_CARD_INLINE_CLASSNAME]: (card, index) => (
    <VideoCardInline
      key={index}
      index={index}
      intcmp={card.intcmp}
      hasPlayIcon
      tag={cardTag}
      href={card.url}
      onClick={handleCardClick}
      imageSrc={card.imageSrc || card.urlImage[deviceType]}
      title={card.title}
      modifiers={cardsStyles[deviceType] ? cardsStyles[deviceType].modifiers : []}
      duration={card.duration}
      publishedTime={card.publishedTime}
      time={card.time}
      ref={cardInstance}
    />
  ),
  [C_VIDEO_CARD_INLINE_SLIM_CLASSNAME]: (card, index) => (
    <VideoCardInlineSlim
      key={index}
      index={index}
      intcmp={card.intcmp}
      tag={cardTag}
      href={card.url}
      imageSrc={card.imageSrc || card.urlImage[deviceType]}
      title={card.title}
      modifiers={cardsStyles[deviceType] ? cardsStyles[deviceType].modifiers : []}
      publishedTime={card.publishedTime}
      time={card.time}
      ref={cardInstance}
    />
  ),
  '': () => {}, // Fallback
});
